import React from "react";

class NoInternetConnection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOnline: true,
    };

    this.handleOnline = this.handleOnline.bind(this);
    this.handleOffline = this.handleOffline.bind(this);
  }

  componentDidMount() {
    // Initial status check
    this.setState({ isOnline: navigator.onLine });

    // Add event listeners
    window.addEventListener("online", this.handleOnline);
    window.addEventListener("offline", this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener("online", this.handleOnline);
    window.removeEventListener("offline", this.handleOffline);
  }

  handleOnline() {
    this.setState({ isOnline: true });
  }

  handleOffline() {
    this.setState({ isOnline: false });
  }

  render() {
    const { isOnline } = this.state;

    if (!isOnline) {
      return (
        <>
          <div className={this.props.style.no_internet_found_container}>
            <div className={this.props.style.error_noresultfound__icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="170"
                height="120"
                viewBox="0 0 170 120"
                fill="none"
              >
                <path
                  d="M89.9066 58.9595C94.4373 58.9595 98.1101 55.6436 98.1101 51.5532C98.1101 47.4628 94.4373 44.1469 89.9066 44.1469C85.3759 44.1469 81.7031 47.4628 81.7031 51.5532C81.7031 55.6436 85.3759 58.9595 89.9066 58.9595Z"
                  fill="#FF8F00"
                />
                <path
                  d="M66.4252 30.7479C65.5015 30.7479 64.5779 30.4299 63.8655 29.8009C62.4252 28.5218 62.4096 26.437 63.8186 25.1366C66.2139 22.9388 75.1454 15.7444 89.4623 15.5536C95.9985 15.4688 102.237 16.8469 107.991 19.6596C112.061 21.6455 114.723 23.7939 115.951 24.8893C117.384 26.1755 117.384 28.2603 115.959 29.5536C114.535 30.8469 112.225 30.8469 110.793 29.5606C109.384 28.2956 101.744 21.9847 89.5641 22.1472C77.7285 22.3027 70.3782 28.5147 69.024 29.7585C68.3117 30.4228 67.3724 30.7479 66.4252 30.7479Z"
                  fill="#FF8F00"
                />
                <path
                  d="M54.7102 20.4505C53.8335 20.4505 52.949 20.1678 52.2445 19.5883C50.7572 18.3587 50.6476 16.2739 52.0097 14.9311C53.7239 13.235 57.4578 9.92053 63.1486 6.81806C66.7259 4.86754 70.5223 3.3057 74.4284 2.18202C79.2112 0.803935 84.1974 0.0689598 89.262 0.0053557C94.4596 -0.0653155 99.6103 0.563658 104.557 1.87814C108.597 2.95235 112.526 4.48591 116.244 6.43644C122.366 9.65198 126.326 13.1997 127.751 14.5707C129.129 15.8993 129.051 17.9912 127.571 19.235C126.099 20.4788 123.782 20.4081 122.405 19.0724C120.229 16.9664 108.557 6.59191 90.0604 6.59191C89.8334 6.59191 89.6064 6.59191 89.3716 6.59897C71.4617 6.84632 60.3775 16.4435 57.4108 19.3834C56.6907 20.0901 55.7044 20.4505 54.7102 20.4505Z"
                  fill="#FF8F00"
                />
                <path
                  d="M77.0509 40.2748C76.1429 40.2748 75.2349 39.9709 74.5225 39.356C73.0666 38.0981 73.0196 36.0062 74.4129 34.6917C75.8376 33.349 81.1448 28.9603 89.6379 28.8472C98.3737 28.7271 103.884 33.1794 105.364 34.5433C106.773 35.8437 106.749 37.9356 105.309 39.2076C103.869 40.4797 101.552 40.4585 100.143 39.1582C99.4618 38.5292 95.8141 35.4409 89.9667 35.4409C89.8963 35.4409 89.818 35.4409 89.7475 35.4409C83.9393 35.5186 80.3464 38.6281 79.6889 39.25C78.9687 39.9355 78.0137 40.2748 77.0509 40.2748Z"
                  fill="#FF8F00"
                />
                <path
                  d="M126.834 107.886C125.55 107.412 122.967 105.532 123.491 104.373L160.282 27.7447C160.806 26.5857 162.27 26.0274 163.554 26.5009C164.837 26.9744 165.456 28.2959 164.931 29.4549L131.233 106.882C130.701 108.041 128.117 108.352 126.834 107.886Z"
                  fill="#43A047"
                />
                <path
                  d="M48.3527 114.529C46.9907 114.755 43.6952 114.415 43.4447 113.186L29.0103 30.6913C28.7598 29.4616 29.6678 28.2814 31.0299 28.0623C32.3919 27.8362 33.6991 28.6559 33.9496 29.8856L51.4682 111.56C51.7187 112.79 49.7147 114.302 48.3527 114.529Z"
                  fill="#43A047"
                />
                <path
                  d="M6.85644 97.8658H163.13C166.723 97.8658 169.635 100.495 169.635 103.739V106.071C169.635 113.767 162.723 120 154.206 120H15.7879C7.26348 120 0.359391 113.76 0.359391 106.071V103.739C0.351563 100.495 3.26349 97.8658 6.85644 97.8658Z"
                  fill="#003366"
                />
                <path
                  d="M126.027 106.268C127.086 106.268 127.945 105.493 127.945 104.537C127.945 103.58 127.086 102.805 126.027 102.805C124.968 102.805 124.109 103.58 124.109 104.537C124.109 105.493 124.968 106.268 126.027 106.268Z"
                  fill="#FF8F00"
                />
                <path
                  d="M147.548 103.583H131.102V105.498H147.548V103.583Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className={this.props.style.no_internet_found_wrap}>
              <h2 className={this.props.style.error_noresultfound__title}>
                Uh-oh, internet’s taking a nap!
              </h2>
              <p className={this.props.style.error_noresultfound__subtitle}>
                Looks like your internet took a break. Let's reconnect to
                continue
              </p>
              <button
                onClick={() => window.location.reload()}
                className={this.props.style.error_noresultfound__button}
              >
                Try Again
              </button>
            </div>
          </div>
        </>
      );
    }

    return null;
  }
}

export default NoInternetConnection;
